export default {
  title: 'Secciones',
  create: 'Nueva sección',
  edit: 'Editar sección',
  headers: {
    name: 'Nombre',
    area: 'Área',
    actions: 'Acciones'
  },
  labels: {
    name: 'Nombre'
  },
  actions: {
    remove: '¿Deseas eliminar la sección: {name}?'
  }
}
